import React from 'react';
import Card from 'react-bootstrap/Card';
import Sidebar from './sidebar';

const InformacionDelSistema = () => {
  return (
    <div>
    <Sidebar>
    <div className="col-md-9">
    <Card>
      <Card.Header className="bg-info text-white" as="h5">Información del Sistema</Card.Header>
      <Card.Body>
        <Card.Text>
          <strong>Nombre del software:</strong> CIRP V16<br />
          <strong>Versión actual:</strong> V16 (Lanzada el 01/02/2025)<br />
          <strong>Propósito:</strong> Constructor de ingresos residuales perpetuos<br />
          <strong>Estado:</strong> En producción<br />
          <strong>Última actualización:</strong> 08/07/2025<br />
          <strong>Tecnologías utilizadas:</strong><br />
          Base de datos: MySQL Versión 5.2.1<br />
          Lenguaje del servidor: PHP 8.1<br />
          <strong>Requisitos mínimos:</strong><br />
          Navegador: Google Chrome (versión 90+)<br />
          RAM: 2 GB<br />
          <strong>Soporte técnico:</strong><br />
          Correo: soporte@mrcirp.com<br />
          Horario: Lunes a Viernes, 9:00 AM - 6:00 PM<br />
          <strong>Métricas:</strong><br />
          Usuarios activos: 500<br />
          Tiempo promedio de respuesta: 200 ms<br />
          <strong>Seguridad:</strong><br />
          Cumple con GDPR y está auditado bajo ISO 27001.<br />
          <strong>Próximas mejoras:</strong><br />
          Integración con IA generadora de recursos<br />
          Panel de administración mejorado.<br />
          video tutoriales.
        </Card.Text>
      </Card.Body>
    </Card>
    </div>
    </Sidebar>
    </div>
  );
};

export default InformacionDelSistema;